export const PasswordRulesMessages = {
  rules: {
    format: {
      id: 'passwordRules.Hint.Format',
      defaultMessage: '{description} {delimitedList}',
    },
    description: {
      id: 'passwordRules.Hint.Description',
      defaultMessage: 'Use at least ',
    },
    minLength: {
      id: 'passwordRules.Hint.MinLength',
      defaultMessage: `{minLength} {minLength, plural, one {character} other {characters}}
                        `,
    },
    capitalLetters: {
      id: 'passwordRules.Hint.CapitalLetters',
      defaultMessage: `, {capitalLetters} capital {capitalLetters, plural, one {letter} other {letters}}
                      `,
    },
    numbers: {
      id: 'passwordRules.Hint.Numbers',
      defaultMessage: `, {numbers} {numbers, plural, one {number} other {numbers}}
                      `,
    },
    specialCharacters: {
      id: 'passwordRules.Hint.SpecialCharacters',
      defaultMessage: `, {specialCharacters} special {specialCharacters, plural, one {character} other {characters}}
                      ! @ # $ % & ) ( + `,
    },
  },
};
